import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import {
  InputOTP,
  InputOTPGroup,
  InputOTPSeparator,
  InputOTPSlot,
} from "@/components/ui/input-otp";
import { useAuth } from "@/hooks/useAuth";
import authProvider from "@/providers/auth.provider";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

export const InvitationSend = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email") || "";
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/dashboard");
    }
  }, [isAuthenticated, navigate]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    if (code.length === 6) {
      setLoading(true);
      const result = await authProvider.checkCode(code, email);
      if (result.success) {
        const link = result.data;
        if (link) {
          window.location.href = link;
        }
      } else {
        setError(result.error || "Invalid code");
        setLoading(false);
      }
    }
  };

  const handleCodeChange = (value: string) => {
    setCode(value);
    setError("");
  };

  return (
    <div className="bg-muted flex min-h-full flex-col items-center justify-center gap-6 p-6 md:p-10">
      <div className="flex w-full max-w-md flex-col gap-6">
        <a href="#" className="flex items-center gap-2 self-center font-medium">
          <img src="/logo-black.svg" alt="Rebuild" className="h-8" />
        </a>
        <Card>
          <CardHeader className="text-center">
            <CardTitle className="text-xl">Check your email</CardTitle>
            <CardDescription>
              We sent a 6-digit code to <span className="font-medium">{email}</span>
            </CardDescription>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit}>
              <div className="grid gap-6">
                <div className="flex flex-col items-center gap-2">
                  <InputOTP
                    maxLength={6}
                    value={code}
                    onChange={handleCodeChange}
                  >
                    <InputOTPGroup>
                      <InputOTPSlot index={0} />
                      <InputOTPSlot index={1} />
                      <InputOTPSlot index={2} />
                    </InputOTPGroup>
                    <InputOTPSeparator />
                    <InputOTPGroup>
                      <InputOTPSlot index={3} />
                      <InputOTPSlot index={4} />
                      <InputOTPSlot index={5} />
                    </InputOTPGroup>
                  </InputOTP>
                  {error && (
                    <p className="text-center text-sm text-destructive">{error}</p>
                  )}
                </div>
                <Button
                  type="submit"
                  className="w-full"
                  disabled={code.length !== 6 || loading}
                >
                  {loading ? "Verifying..." : "Verify Code"}
                </Button>
              </div>
            </form>
          </CardContent>
        </Card>
        <div className="text-balance text-center text-xs text-muted-foreground">
          Didn't receive a code?{" "}
          <a href="/" className="underline underline-offset-4 hover:text-primary">
            Try again
          </a>
        </div>
      </div>
    </div>
  );
};
